import { createContext } from 'react';

export const PRODUCT_CONTEXT = createContext();
export const ProductContextProvider = PRODUCT_CONTEXT.Provider;

export default { ProductContextProvider, PRODUCT_CONTEXT };
